import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import { Content } from './CardContent';
// import { QuestionCount } from './QuestionCount';
import Event from '../../models/Event';
import { ActionButtons, DialogModalWindow } from 'src/components/shared';
import rank1 from 'src/images/rank-1.svg';
import rank2 from 'src/images/rank-2.svg';
import rank3 from 'src/images/rank-3.svg';
import { HistoryContext, PayWallContext } from '../NewDashboard';
import { NavigationUtils } from '../../util/NavigationUtils';
import {
  deleteEventOrPrioritize,
  fetchEventsAndPrioritize,
} from '../../actions/event';
import { fetchCollection } from 'src/actions/prioritize';

const defaultTrophy = [{ id: '', title: '', text: 'No Activity' }];
const loadingTrophy = [{ id: '', title: '', text: 'loading...' }];

const NewCard = ({
  user,
  event,
  isSelected,
  handleCopy,
  handleDelete,
  refreshEvents,
  stats = [],
  isLoadingStats,
  deleteEventOrPrioritize,
  fetchEventsAndPrioritize,
  fetchCollection,
  deleteSuccessful,
}) => {
  const history = useContext(HistoryContext);
  const {onChange} = useContext(PayWallContext);
  const [isArchiveModal, setIsArchiveModal] = useState(false);
  const { id, collection_type, question_type, slug, collection, title } = event;

  const productType =
    event.collection?.type === 'survey' ? 'survey' : 'crowdsource';
  const editURL = `/r/${productType}/${slug}/edit`;

  const mapCasesToLinks = {
    prioritize: { results: `/r/p/${id}`, edit: `/r/p/${id}/edit` },
    default: { results: `/q/${slug}/answers`, edit: editURL },
    binary: { results: `/q/${slug}/answers`, edit: editURL },
    scale: { results: `/q/${slug}/answers`, edit: editURL },
    multiple_rating: { results: `/q/${slug}/answers`, edit: editURL },
    stack_rank: { results: `/q/${slug}/answers`, edit: editURL },
    multiple: { results: `/q/${slug}/answers`, edit: editURL },
  };

  const mapQuestionTypesToCases = {
    prioritize: {
      type: 'prioritize',
      trophy: 'rank',
      link: mapCasesToLinks.prioritize,
    },
    default: {
      type: 'legacy',
      trophy: 'responses',
      link: mapCasesToLinks.default,
    },
    binary: {
      type: 'legacy',
      trophy: 'top_choice',
      link: mapCasesToLinks.binary,
    },
    scale: {
      type: 'legacy',
      trophy: 'avg_rating',
      link: mapCasesToLinks.scale,
    },
    multiple_rating: {
      type: 'legacy',
      trophy: 'top_choice',
      link: mapCasesToLinks.multiple_rating,
    },
    stack_rank: {
      type: 'legacy',
      trophy: 'top_choice',
      link: mapCasesToLinks.stack_rank,
    },
    multiple: {
      type: 'legacy',
      trophy: 'top_choice',
      link: mapCasesToLinks.multiple,
    },
  };

  const trophyIcons = [rank1, rank2, rank3];
  let trophyTypes = {};
  try {
    trophyTypes = {
      rank: (stats) =>
        stats.map((stat, idx) => ({
          id: idx,
          title: `RANK${idx + 1}`,
          text: stat?.title || '',
          icon: trophyIcons[idx] || null,
        })),
      avg_rating: (stats) =>
        stats.map((stat) => ({
          id: 'avg',
          title: 'AVERAGE RATING',
          text: stat?.summary?.simple_score_display || '',
          icon: trophyIcons[0],
        })),
      top_choice: (stats) =>
        stats.map((stat) => ({
          id: 'top',
          title: 'TOP CHOICE',
          text: stat?.summary?.winning_ideas
            ? stat?.summary?.winning_ideas[0]?.title
            : 'N/A',
          icon: trophyIcons[0],
        })),
      responses: (stats) =>
        stats.map((stat) => ({
          id: 'res',
          title: 'RESPONSES',
          text: stat?.metrics?.ideas,
          icon: trophyIcons[0],
        })),
    };
  } catch (error) {
    console.log('error', error);
  }

  const collectionTypeProperties =
    mapQuestionTypesToCases[collection_type || question_type] || {};

  const handleClick = () => {
    if (collectionTypeProperties.type === 'legacy') {
      NavigationUtils.routeToLegacy(collectionTypeProperties.link.results);
    } else {
      fetchCollection(id);
      history.push(collectionTypeProperties.link.results);
    }
  };

  const handleEditClick = () => {
    history.push(collectionTypeProperties.link.edit);
  };

  const handleDeleteClick = () => {
    setIsArchiveModal(true);
  };

  const handleArchive = (e) => {
    e.stopPropagation();
    setIsArchiveModal(false);
    deleteEventOrPrioritize({
      id: collection ? collection.id : id,
      type: collectionTypeProperties.type,
      text: collection?.name || title,
    });
  };

  const handleCloseModal = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setIsArchiveModal(false);
  };

  const trophyType = collectionTypeProperties.trophy || 'responses';

  const trophies = isLoadingStats
    ? loadingTrophy
    : trophyTypes[trophyType](stats.slice(0, 3));

  // const isPrioritize = !!event.collection_type

  return (
    <>
      <div
        style={{ overflow: 'hidden' }}
        id={`card-${Event.getId(event)}`}
        className={`card summary-card clickable prioritize`}
        onClick={() => handleClick()}
      >
        {!!event.sample && <span className="card-label sample">SAMPLE</span>}

        {!!event.collection_type ? (
          <div className="card-label popin-type">PRIORITIZE</div>
        ) : (
          <div className="card-label popin-type">
            {event.collection?.type === 'survey' ? 'SURVEY' : 'CROWDSOURCE'}
          </div>
        )}

        <div className="">
          {!!event.sample && (
            <small className="text-uppercase font-weight-bold sample_type">
              {event.question_type_label}
            </small>
          )}
          {/* <div className="row no-gutters list-item card-list-card-header"></div> */}
          <div className={`card-content margin-top`}>
            <Content user={user} event={event} />
            {/* <div className="row no-gutters">
              <QuestionCount user={user} event={event} />
            </div> */}
            <div className="row no-gutters ranks-container">
              {(trophies.length ? trophies : defaultTrophy).map(
                ({ id, icon, title, text }) => (
                  <div key={id} className="rank-container">
                    <div className="rank">
                      {icon && (
                        <div className="img-container">
                          <img src={icon} alt={text} />
                        </div>
                      )}
                      <div className="rank-text">
                        <h4> {title}</h4>
                        <span>{text}</span>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
                      
        {event?.user_created && (
          <ActionButtons
            onEditClick={() => onChange(handleEditClick)}
            onDeleteClick={() => onChange(handleDeleteClick)}
          />
        )}

        <DialogModalWindow
          isOpen={isArchiveModal}
          title="Are you sure you want to archive this POPin?"
          confirmBtnText="Yes, archive"
          onCancel={handleCloseModal}
          onConfirm={handleArchive}
        >
          <h3 style={{ textAlign: 'center' }}>
            You will not be able to undo this action.
          </h3>
        </DialogModalWindow>
      </div>
      <hr className="mobile-card-divider" />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    deleteSuccessful: state.event.deleteSuccessful,
  };
};

const mapDispatchToProps = {
  deleteEventOrPrioritize,
  fetchEventsAndPrioritize,
  fetchCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCard);
